export const EXCLUDED_BRANDS = ['No name', 'Unbranded']
